import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { colors, css, fonts } from "../../Styles";
import { Button, PrimaryPopover } from "..";
import { AttentionTypes, CreateAttentionStyles, ButtonTypes } from "../../Definitions";

// TODO
import { useAppSelector } from "../../Store";
import { Graph_QL } from "../../Services";
import { useSystem } from "../../Services/Agrisys_GqlDataCaller/SystemCalls/useSystem";

interface AttentionPopover_Props {
  systemNo: number
  onGoToSystemClick?: () => void
}
/**
 * AttentionPopover
 * @param systemNo Identifier for the system, used to retrieve system details.
 * @param onGoToSystemClick Optional callback for "Go to system" button click.
 * @returns A popover build from the BaseUI StatefulPopover
 */
export default function AttentionPopover({ systemNo, onGoToSystemClick}: AttentionPopover_Props) {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = useState(false)

  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]);;

  const {call: getSystemCall, data: systemsState} = useSystem(connection); 
  
  useEffect(() => {
    getSystemCall({fetchAmount: 50})
  },[])

  // Lookup system data based on systemNo
  const { systemName, systemType, attentionType } = useMemo(() => {
    const systemData = systemsState[domain]?.data.find((system) => system.systemId === systemNo);
    return {
      systemName: systemData?.name || "",
      systemType: systemData?.systemType || "",
      attentionType: AttentionTypes.neutral, // TODO 
    };
  }, [domain, systemNo, systemsState]);

  const { textColor, attentionText, attentionColor } = useMemo(() => {
    var _Style = CreateAttentionStyles(t, attentionType)
    return _Style
  }, [t, attentionType ]);
  
  return (
    <PrimaryPopover
      content="" // onClick={() => setIsOpen(true)}
      popoverHeader={attentionText}
      overrides={{
        contentContainer: {
          height: "10px",
          width: "30px",
          backgroundColor: attentionColor,
          borderRadius: "10px",
          cursor: "pointer"
        },
        popoverBgColor: attentionColor as typeof colors[keyof typeof colors],
        popoverHeaderFontSize: { ...fonts.fontSize4 }
      }}
      
      popoverContent={
        <div style={{padding: "10px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
          <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{systemName}</p>
          <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyPrimary}}>{systemType}</p>
          <div style={{marginTop: "10px"}}>
            { attentionType === AttentionTypes.alert || attentionType === AttentionTypes.warning
              ? <Button 
                  content={t("attentions.goToSystem")} 
                  onClick={onGoToSystemClick}
                  buttonType={ButtonTypes.textButton}
                  overrides={{
                    contentStyles: {color: textColor, ...fonts.fontSize4},
                    baseButton: {backgroundColor: attentionColor, width: "120px", height: "25px"}
                  }}
                />
              : <></> 
            }
          </div>
        </div>
      }
    />
  )
}